<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="project-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @bidderChange="bidderChange"
        @serviceTypeChange="serviceTypeChange"
        @projectStatusChange="projectStatusChange"
        @platformCompanyNameChange="platformCompanyNameChange"
        @createDepartmentNoChange="createDepartmentNoChange"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          @dblclickEvent="dblclickEvent"
          :loading="loading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'projectBusinessTypeNo'">
                {{ getBusinessTypeName(scope.row[item.field]) }}
              </span>
              <span v-else-if="item.field == 'projectStatus'">
                {{ getStatusName('project', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'projectSort'">
                {{
                  scope.row[item.field] == 'sp'
                    ? '中小项目'
                    : scope.row[item.field] == 'bp'
                    ? '重大项目'
                    : ''
                }}</span
              >
              <span v-else-if="item.field == 'projectSourceType'">
                {{ getProjectSourceType(scope.row[item.field]) }}</span
              >
              <template v-else-if="item.field == 'oaUrl'">
                <a
                  href="javascript:void(0);"
                  v-if="scope.row[item.field]"
                  @click="goOaLink(scope.row[item.field])"
                  >查看</a
                >
              </template>
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <ProjectRevokeDialog ref="revokeDialogRef" @handleSure="handleRevoke"></ProjectRevokeDialog>
      <ProjectToContractDialog
        ref="toContractDialogRef"
        @handleSure="getContractType"
      ></ProjectToContractDialog>
      <SelectPartnerDialog
        ref="selectPartnerDialogRef"
        :isRadio="isUpOrDown !== '0'"
        @confirm="getPartnerType"
      ></SelectPartnerDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import ProjectServiceMixin from '../projectDetail/ProjectServiceMixin';
  import IntermodalityCommonMixin from '../../common/mixins/IntermodalityCommonMixin';
  import { searchColumns } from './columns/searchColumns';
  import { defaultTableColumns } from './index.js';
  import ProjectRevokeDialog from '@/pages/intermodality/project/projectOverview/components/projectRevokeDialog';
  import ProjectToContractDialog from '@/pages/intermodality/project/projectOverview/components/projectToContractDialog';
  import SelectPartnerDialog from './components/SelectPartnerDialog.vue';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'ProjectOverview',
    mixins: [ProjectServiceMixin, IntermodalityCommonMixin],
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.getButtonList();
      this.getCompanyList();
      // this.$nextTick(() => {
      //   this.getTableData();
      // });
    },
    data() {
      return {
        loading: false,
        tableColumns: [],
        queryData: { createDepartmentNo: null },
        bidderIds: null,
        bidderName: null,
        menuButtonList: [], // 表格功能按钮
        tableData: [], // 表格数据
        selectedItems: [],
        departmentList: [],
        companyList: [],
        isUpOrDown: '',
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    methods: {
      getContractType(val) {
        let isUpOrDown = val;
        this.isUpOrDown = val;
        let projectCode = this.selectedItems[0].projectCode;
        this.$refs.selectPartnerDialogRef.openModal(projectCode, isUpOrDown);
      },
      // this.$emit('confirm', selection, this.query);
      getPartnerType(partner, query) {
        let partnerCode;
        if (query.isUpOrDown == '0') {
          partnerCode = partner
            .map((v) => (query.isUpOrDown == '0' ? v.upPartnerCode : v.downPartnerCode))
            .join(',');
        } else {
          partnerCode = query.isUpOrDown == '0' ? partner.upPartnerCode : partner.downPartnerCode;
        }
        this.convertContract(query.isUpOrDown, query.projectCode, partnerCode);
        // this._convert(
        //   val,
        //   this.selectedItems[0].projectCode
        //   // this.selectedItems[0].isConversionContract
        // );
      },
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        // this.$refs.searchRef.$refs.saleDepartmentName[0].resetClick();
        // this.$refs.searchRef.$refs.createDepartmentName[0].resetClick();
        this.queryData = {};
        this.getTableData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },

      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData(true);
      },

      async handleRevoke(reason) {
        console.log(reason);
        await this.revoke(this.selectedItems[0].projectCode, reason);
        this.getTableData();
      },
      bidderChange(rows) {
        let nameList = [];
        let idList = [];
        if (rows.val) {
          rows.val.forEach(function (row) {
            nameList.push(row.personName);
            idList.push(row.id);
          });
        }
        this.bidderIds = idList;
        this.bidderName = nameList;
        console.log('bidderIds', idList);
      },

      platformCompanyNameChange(row) {
        this.queryData.platformCompanyName = this.companyList.find((item) => {
          item.personCompanyCode == row.val;
        })?.personCompanyName;
        this.queryData = {
          ...this.queryData,
          createDepartmentName: null,
          createDepartmentNo: null,
        };
        if (!row.val) {
          this.departmentList = [];
        } else {
          this.department(row.val);
        }
      },

      createDepartmentNoChange(row) {
        console.log(row, 'row--');
        this.queryData.createDepartmentNo = row.val;
        this.queryData.createDepartmentName = this.departmentList.find(
          (item) => item.value == row.val
        )?.label;
      },

      serviceTypeChange(rows) {
        let idList = [];
        if (rows.val) {
          rows.val.forEach(function (row) {
            idList.push(row);
          });
        }
        this.queryData.serviceTypeCodes = idList;
        console.log('serviceType', idList);
      },
      projectStatusChange(rows) {
        let idList = [];
        if (rows.val) {
          rows.val.forEach(function (row) {
            idList.push(row);
          });
        }
        this.queryData.projectStatus = idList;
        console.log('projectStatus', idList);
      },
      // platformCompanyChange(rows) {
      //   console.log('platformCompanyChange', rows);
      //   if (rows.val) {
      //     this.queryData.platformCompanyCode = rows.val.value;
      //     this.queryData.platformCompanyName = rows.val.label;
      //   }
      // },
      dblclickEvent({ row }) {
        this.toDetail(row.projectCode, 'detail');
      },
      toDetail(projectCode, origin = 'create') {
        let query = {};
        let title = '';
        let suffix = 'projectCreation';
        query.pageMode = 1;
        query.origin = origin;
        if (origin == 'create') {
          title = '新建项目';
          query.pageMode = 0;
        } else if (origin == 'copy') {
          title = '新建项目';
          query.projectCode = projectCode;
        } else if (origin == 'detail') {
          title = '项目详情';
          query.projectCode = projectCode;
        }
        if (origin == 'detail') {
          suffix = 'projectDetail';
        }

        let path = {
          path: '/intermodality/' + suffix,
          name: suffix,
          meta: {
            keepAlive: false,
            title: title,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表格上面的按钮
      chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        // 已保存;xmzt01;审批中;xmzt02;审批通过;xmzt03;已驳回;xmzt04;执行中;xmzt05;已作废;xmzt06;
        let projectStatus = justOne ? this.selectedItems[0].projectStatus : '';
        let projectCode = justOne ? this.selectedItems[0].projectCode : '';

        let statusName = this.getStatusName('project', projectStatus);

        console.log('listStatus', empty, justOne);

        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          this.toDetail(null, type);
        } else if (type == 'revoke') {
          if (justOne) {
            if (statusName == '审批通过' || statusName == '已保存') {
              this.$refs.revokeDialogRef.openDialog();
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '请选择审批通过或已保存的数据!',
              });
            }
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
        } else if (type == 'convert') {
          if (justOne) {
            if (projectStatus == 'xmzt03' || projectStatus == 'xmzt05') {
              this.$refs.toContractDialogRef.openDialog();
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '请选择审批通过或者执行中的数据!',
              });
            }
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
        } else if (type == 'copy') {
          if (justOne) {
            this.toDetail(projectCode, 'copy');
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
        } else if (type == 'withdrawApprovalHandler') {
          this.withdrawApprovalHandler();
        }
      },
      withdrawApprovalHandler() {
        if (!this.selectedItems.length) {
          this.$message.error('请选择行操作');
          return;
        }
        // 判断只有审批中
        if (this.selectedItems.some((item) => item.projectStatus != 'xmzt02')) {
          this.$message.error('只有审批中才可以撤回审批');
          return false;
        }
        const ids = this.selectedItems.map((item) => item.id);
        this.loading = true;
        this.$axios
          .post('/sales/mtoProject/withdrawOA', ids)
          .then((res) => {
            console.log(res);
            this.loading = false;
            const { code, msg } = res.data;
            if (code == 0) {
              this.resetBtnClick();
              this.$message.success('撤回成功');
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      // 获取表格数据
      async getTableData(search = false) {
        // console.log(search, '搜索');
        let params = {};
        if (search) {
          // if (!this.validateSearch()) {
          //   return;
          // }
          // params.createDepartmentName = null;
          // params.saleDepartmentName = null;
        }
        params = this.queryData;

        // if (params.createDepartmentName) {
        //   params.createDepartmentNos = params.createDepartmentName.split(',');
        //   params.createDepartmentName = null;
        // }

        // if (params.saleDepartmentName) {
        //   params.saleDepartmentNos = params.saleDepartmentName.split(',');
        //   params.saleDepartmentName = null;
        // }

        if (params.bidTitles && params.bidTitles.length != 0) {
          params.bidTitles = params.bidTitles.map((id) => {
            let title = this.signTitleList.find((item) => item.value == id);
            if (title) {
              return title.label;
            }
            return '';
          });
        }

        // if (params.platformCompanyName) {
        //   let company = this.platformCompanyList.find(
        //     (item) => item.value == params.platformCompanyName
        //   );
        //   if (company) {
        //     params.platformCompanyName = company.label;
        //   }
        // }

        params.bidderIds = this.bidderIds;
        params.bidderName = this.bidderName;

        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.adminFlag = this.userInfo.adminFlag;
        params.isSelectAll = 1;
        // params.platformCompanyCode = this.userInfo.companyCode;
        this.loading = true;
        var res = await this.getProjectList(this.filterEmpty(params));
        if (res) {
          this.tableData = res.records || [];
          //清空选择fixme
          this.$refs.siruiTable.setPageTotal(res.total);
          // this.$refs.siruiTable.setPageSize(res.size);
          this.selectedItems = [];
        }

        this.loading = false;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },

      async getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        this.companyList = res.data.data?.personCompanyInfo.filter((item) => {
          return item.personCompanyCode != 'OAC19';
        });
        console.log(res.data.data.personCompanyInfo, this.companyList);
        if (this.userInfo.companyCode != 'OAC19') {
          this.queryData = {
            ...this.queryData,
            platformCompanyName: this.userInfo.companyName,
            platformCompanyCode: this.userInfo.companyCode,
          };
        }
        if (this.queryData.platformCompanyCode) {
          this.department(this.queryData.platformCompanyCode);
        }
        this.getTableData();
      },

      // 获取部门
      department(contractCompanyNo) {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: contractCompanyNo,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo || [];
            if (this.departmentList.length)
              this.departmentList = this.departmentList.map((item) => {
                return {
                  ...item,
                  value: item.personDepartmentCode,
                  label: item.personDepartmentName,
                };
              });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
    components: {
      SiruiSearch,
      ProjectRevokeDialog,
      ProjectToContractDialog,
      SelectPartnerDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
